'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { cn } from '@/utils/cn-tw-merge';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { partnerUrl } from '@/utils/consts/partner.consts';

export const PartnerSimplifyScheduleSection = () => {
  return (
    <section
      data-testid={DataTestIdEnum.FAQ_PARTNER_SIMPLIFY_SCHEDULE}
      className="bg-[linear-gradient(281deg,_#095E3A_33.66%,_#0D9259_66.34%)] xl:bg-gray-50 xl:[background-image:none]"
    >
      <ContentContainer className="xl:pb-10">
        <div className="flex flex-col items-center xl:rounded-2xl py-10 lg:py-16 xl:py-10 xl:bg-[linear-gradient(281deg,_#095E3A_33.66%,_#0D9259_66.34%)]">
          <Typography
            variant={TypographyVariant.LARGE_SUBTITLE}
            className="mb-1 text-center font-bold text-white"
          >
            Simplifique a sua agenda
          </Typography>

          <Typography
            variant={TypographyVariant.MEDIUM_SUBTITLE}
            className="mb-6 text-center text-white"
          >
            Descubra o poder do Agendamento Online com a Medprev.
          </Typography>

          <div
            className={cn(
              'sm:w-75 xl:w-[38.5rem]',
              'flex w-full flex-col justify-center gap-4 xl:flex-row',
            )}
          >
            <Button variant="default" color="success" asChild data-analytics-event={AnalyticsEnum.CLICK_PARTNER_SIMPLIFY_SCHEDULE_FAQ}>
              <Link href={partnerUrl} target="_blank">
                Quero saber mais
              </Link>
            </Button>
          </div>
        </div>
      </ContentContainer>
    </section>
  );
};
